import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'

@withMutation(gql`
  mutation resendVerificationEmail($email: String) {
    resendVerificationEmail(email: $email) {
      success
    }
  }
`)
@withGraphQL(gql`
  query me {
    me {
      _id
      emails {
        address
        verified
      }
      isActive
      roles
      isSimpleAccount
      hasPassword
      lastKnownLocation {
        date
      }
    }
  }
`)

@withMutation(gql`
  mutation setSimpleAccount($isSimpleAccount: Boolean) {
    setSimpleAccount(isSimpleAccount: $isSimpleAccount){
      success
    }
  }
`)

@withMessage
export default class State extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    me: PropTypes.func,
    setSimpleAccount: PropTypes.func
  }

  state = {}

  async sendEmail() {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.resendVerificationEmail({email: this.props.me.emails[0].address})
      this.props.showMessage('Email de confirmación enviado a tu correo.')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderActive() {
    return (
      <div className={styles.notact}>
        <div className="row">
          <div className="col-xs-12 col-sm-3">Esta cuenta se encuentra:</div>
          <div className="col-xs-12 col-sm-8">
            <div className={styles.activa}> ACTIVA</div>
          </div>
        </div>
        <br />
        <div className={styles.notact}>
          Esta cuenta esta habilitada para enviar documentos a firmar y firmarlos.
        </div>
      </div>
    )
  }

  renderNotAct() {
    return (
      <div className={styles.notact}>
        <div className="row">
          <div className="col-xs-12 col-sm-3">Esta cuenta se encuentra:</div>
          <div className="col-xs-12 col-sm-8">
            <div className={styles.inactiva}> INACTIVA</div>
          </div>
        </div>
        <br />
        <div className={styles.notact}>
          Si tu cuenta se encuentra inactiva estarás inhabilitado para firmar documentos y enviarlos
          a firmar. No se te limitará la navegación por la plataforma, pero no puedes ocupar sus
          funcionalidades.
        </div>
        <br />
        <Button primary onClick={() => this.sendEmail()} loading={this.state.loading}>
          Verificar email
        </Button>
      </div>
    )
  }

  renderToggleSimpleAccount(isSimpleAccount){
    if(isSimpleAccount){
      return(
        <div className="content">
          <Button className={styles.btnBlock} onClick={async form => {
            await this.props.setSimpleAccount({
                isSimpleAccount: false
            },
            {
              refetchQueries: [
                'me'
              ]
            }
            )
            this.props.showMessage('Usuario actualizado')
          }}>Permitir creación de documentos</Button>
        </div>
      )
          
    } else {
      return(
        <div className="content">
          <Button className={styles.btnBlock} onClick={async form => {
            await this.props.setSimpleAccount({
                isSimpleAccount: true
            },
            {
              refetchQueries: [
                'me'
              ]
            })
            this.props.showMessage('Usuario actualizado')
          }}>Activar modo sencillo (sin creación de documentos)</Button>
        </div>
      )
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Estado de cuenta</h3>
          </div>
          <div className="content">
            {this.props.me.emails[0].verified ? this.renderActive() : this.renderNotAct()}
          </div>
          {this.renderToggleSimpleAccount(this.props.me.isSimpleAccount)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/State/index.js